module.exports = __webpack_public_path__ + "media/images/Warm-Abstract-3-30ae4aae1c45bc8582e43e461e54e83a.png";